import React from 'react';
import EventDetails from './EventDetails';
import DressCodeModal from './DressCodeModal';

function ConfirmationScreen({
    alreadyConfirmed,
    showDressCodeModal,
    onOpenMaps,
    onAddToCalendar,
    onOpenDressCode,
    onCloseDressCode
}) {
    return (
        <div className="App">
            <div className="invitation-card success-card">
                <div className="ornament-top"></div>
                <h1 style={{ fontFamily: "'Cormorant Garamond', cursive", fontSize: '2.5rem', fontWeight: '400', color: '#d4af37' }} className="elegant-title">
                    {alreadyConfirmed ? 'Già Confermato!' : 'Grazie!'}
                </h1>
                <div className="divider"></div>

                <EventDetails
                    onOpenMaps={onOpenMaps}
                    onAddToCalendar={onAddToCalendar}
                />

                <p style={{ color: '#d4af37' }} className="confirmation-text">
                    {alreadyConfirmed
                        ? 'Hai già confermato la tua partecipazione!'
                        : 'La tua conferma è stata ricevuta con successo.'
                    }
                </p>
                <p style={{ color: '#d4af37' }} className="confirmation-subtext">
                    Non vedo l'ora di festeggiare assieme!
                </p>
                <div className="ornament-bottom"></div>
            </div>

            <DressCodeModal isOpen={showDressCodeModal} onClose={onCloseDressCode} />
        </div>
    );
}

export default ConfirmationScreen;
